import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const OuvrirPage = () => {
  const [searchParams] = useSearchParams();
  const destination = searchParams.get('destination') || '';
  const questionId = searchParams.get('questionId') || '';
  const childId = searchParams.get('child_id') || '';

  useEffect(() => {
    // Construire le deep link natif
    let schemeUrl = `dismaman://${destination}`;
    const params = [];
    if (questionId) params.push(`id=${questionId}`);
    if (childId) params.push(`child_id=${childId}`);
    if (params.length > 0) schemeUrl += `?${params.join('&')}`;

    // Construire le fallback web
    let webUrl = `/quiz/newsletter/${questionId}`;
    if (childId) webUrl += `?child_id=${childId}`;

    // Tenter d'ouvrir l'app native
    window.location.href = schemeUrl;

    // Fallback vers le web après 500ms si l'app ne s'ouvre pas
    const timer = setTimeout(() => {
      window.location.href = webUrl;
    }, 500);

    return () => clearTimeout(timer);
  }, [destination, questionId, childId]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #B8D4E3 0%, #A7D3D8 30%, #9ECDC4 60%, #B5DCAE 100%)',
    }}>
      <p style={{ color: '#666', fontSize: '15px' }}>Chargement...</p>
    </div>
  );
};

export default OuvrirPage;
